export const typeofBoolean = value => typeof value === 'boolean';
export const nonNullable = value => value != null;
export const hasOwnProperty = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);